(function () {
    /* Initializes the wishlist functions by fetching the list and adding event listeners. */
    const init = (swat) => {
        console.log('Swym Wishlist Init');
        let lists = fetchList(swat);
        if (!window.swymSelectedListId) {
            createList(swat);
        }
        addSwymEventListener(swat);
    };

    /* Create a new wishlist if it doesn't already exist. */
    const createList = (swat) => {
        let listConfig = { "lname": "My Wishlist" };

        let onSuccess = function ({ lid }) {
            console.log("Successfully created a new List", lid);
            window.swymSelectedListId = lid;
        }

        let onError = function (error) {
            console.log("Error while creating a List", error);
        }

        swat.createList(listConfig, onSuccess, onError);
    }

    /* Fetches the wishlist data. */
    const fetchList = async (swat) => {
        return new Promise((resolve, reject) => {
            const onSuccess = (lists) => {
                console.log("Fetched all Lists", lists);

                const wishlistCount = document.querySelector('.wishlist-count');

                if (wishlistCount) {
                    wishlistCount.innerHTML = lists[0].cnt;
                }


                window.swymWishLists = lists;
                window.swymSelectedListId = lists && lists[0] && lists[0].lid;
                resolve(lists);
                updateButtonState();
            };

            const onError = (error) => {
                console.log("Error while fetching all Lists", error);
                reject(error);
            };

            if (!window.swymWishLists) {
                swat.fetchLists({
                    callbackFn: onSuccess,
                    errorFn: onError
                });
            } else {
                resolve(window.swymWishLists);
            }
        });
    };

    /* Refreshes the wishlist by fetching the list again in the global scope. */
    const refreshList = async (swat) => {
        window.swymWishLists = null;
        await fetchList(swat);
    };

    /* Adds product to wishlist action. */
    const addToWishlist = (swat, product) => {
        let onSuccess = async function (addedListItem) {
            console.log('Product has been added to wishlist!', addedListItem);
        }

        let onError = function (error) {
            swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
        }

        let lid = window.swymSelectedListId;

        swat.addToList(lid, product, onSuccess, onError);
    }

    /* Remove product from wishlist action. */
    const removeFromWishlist = (swat, product) => {
        let onSuccess = async function (deletedProduct) {
            console.log('Product has been removed from wishlist!', deletedProduct);
        }

        let onError = function (error) {
            swat.ui.showErrorNotification({ message: "Error removing Product from Wishlist" });
        }

        let lid = window.swymSelectedListId;

        swat.deleteFromList(lid, product, onSuccess, onError);
    }

    /* Updates the state of wishlist buttons based on whether items are wishlisted. */
    const updateButtonState = () => {
        const swymWishlistButtons = document.querySelectorAll('swymcs-wishlist-button');
        const swymWishlistButtonsApp = Array.from(document.querySelectorAll('.swym-wishlist-collections-v2'));

        if (swymWishlistButtons) {
            swymWishlistButtons.forEach((swymWishlistButton) => {
                const elements = swymWishlistButton.elements;
                if (!elements) return; // Skip if elements not initialized yet

                const { epi, empi } = elements.wishlistButton.dataset;
                let isWishlisted = false;

                if (window.swymWishLists) {
                    window.swymWishLists.forEach(list => {
                        list.listcontents.forEach(item => {
                            if (item.empi == empi && item.epi == epi) {
                                isWishlisted = true;
                            }
                        });
                    });
                    updateButtonWishlistState(elements, isWishlisted);
                }
            });
        }

        if (swymWishlistButtonsApp) {
            swymWishlistButtonsApp.forEach((swymWishlistButton) => {

                const productId = swymWishlistButton.dataset.productId;
                if (!productId) return; // Skip if elements not initialized yet

                let isWishlisted = false;

                if (window.swymWishLists) {
                    window.swymWishLists.forEach(list => {
                        list.listcontents.forEach(item => {
                            const productHandle1 = item.du.split('/').pop();
                            const productHandle2 = productId.split('/').pop();
                            if (productHandle1 == productHandle2) {
                                isWishlisted = true;
                            }
                        });
                    });

                    const svg = swymWishlistButton.querySelector('svg');

                    if (isWishlisted) {
                        svg.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_620_406)">
                                <path class="swym-wishlist-collections-icon-heart-filled" d="M12 21C11.8684 21.0008 11.7379 20.9755 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.52 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23C1.99866 7.84443 2.54536 6.51482 3.52 5.53C4.50226 4.55051 5.83283 4.00047 7.22 4.00047C8.60717 4.00047 9.93774 4.55051 10.92 5.53L12 6.61L13.08 5.53C14.0623 4.55051 15.3928 4.00047 16.78 4.00047C18.1672 4.00047 19.4977 4.55051 20.48 5.53C21.4546 6.51482 22.0013 7.84443 22.0013 9.23C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9755 12.1316 21.0008 12 21Z"></path>
                                </g>
                                <defs><clipPath id="clip0_620_406">  <rect width="24" height="24" fill="white"></rect></clipPath></defs>
                                </svg>`
                    } else {
                        svg.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_620_405)">
                                <path class="swym-wishlist-collections-icon-heart-unfilled" d="M12 21C11.8684 21.0008 11.7379 20.9755 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.52 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23C1.99866 7.84443 2.54536 6.51482 3.52 5.53C4.50226 4.55051 5.83283 4.00047 7.22 4.00047C8.60717 4.00047 9.93774 4.55051 10.92 5.53L12 6.61L13.08 5.53C14.0623 4.55051 15.3928 4.00047 16.78 4.00047C18.1672 4.00047 19.4977 4.55051 20.48 5.53C21.4546 6.51482 22.0013 7.84443 22.0013 9.23C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9755 12.1316 21.0008 12 21ZM7.22 6C6.79668 5.99808 6.37718 6.08018 5.98581 6.24154C5.59444 6.40289 5.23897 6.6403 4.94 6.94C4.33606 7.54712 3.99704 8.36865 3.99704 9.225C3.99704 10.0814 4.33606 10.9029 4.94 11.51L12 18.58L19.06 11.51C19.6639 10.9029 20.003 10.0814 20.003 9.225C20.003 8.36865 19.6639 7.54712 19.06 6.94C18.4437 6.35771 17.6279 6.0333 16.78 6.0333C15.9321 6.0333 15.1163 6.35771 14.5 6.94L12.71 8.74C12.617 8.83373 12.5064 8.90812 12.3846 8.95889C12.2627 9.00966 12.132 9.0358 12 9.0358C11.868 9.0358 11.7373 9.00966 11.6154 8.95889C11.4936 8.90812 11.383 8.83373 11.29 8.74L9.5 6.94C9.20103 6.6403 8.84556 6.40289 8.45419 6.24154C8.06282 6.08018 7.64332 5.99808 7.22 6Z"></path>
                                </g>
                                <defs><clipPath id="clip0_620_405"><rect width="24" height="24" fill="white"></rect></clipPath></defs>
                            </svg>`
                    }
                }
            });
        }
    };

    /* Updates the display state of a wishlist button based on whether the itePm is wishlisted. */
    const updateButtonWishlistState = (elements, isWishlisted) => {
        if (!elements || !elements.wishlistButton) return;

        let settings = {};
        try {
            settings = JSON.parse(elements.wishlistButton.dataset.settings || '{}');
        } catch (e) {
            console.error('Error parsing settings:', e);
            settings = {};
        }

        elements.filledState.style.display = isWishlisted ? 'flex' : 'none';
        elements.unfilledState.style.display = isWishlisted ? 'none' : 'flex';
        if (isWishlisted) {
            elements.wishlistButton.classList.add('swym-added-custom');
            if (settings.disable_added_to_wishlist) {
                elements.wishlistButton.setAttribute('disabled', true);
            }
        } else {
            elements.wishlistButton.classList.remove('swym-added-custom');
            elements.wishlistButton.classList.remove('disabled');
            elements.wishlistButton.removeAttribute('disabled');
        }
    };

    /* Render multiple wishlist popup when multiple wishlist enabled */
    const renderPopup = async (product) => {
        let popup = document.querySelector('swym-wishlist-popup');
        if (!popup) return;

        let { epi, empi, du } = product;
        window.currentActiveProduct = await fetchProductsData(du);
        window.currentActiveVariant = currentActiveProduct.variants.find((variant) => variant.id == epi);
        window.currentActiveVariantId = epi;
        window.currentActiveProduct.url = du;
        setTimeout(popup._show.bind(popup), 100);
    }

    /* Fetches product data from shopify to get updated data. */
    const fetchProductsData = async (url) => {
        try {
            const productData = await fetch(`${url}.js`);
            if (productData.status === 404 || !productData.ok) return null;
            const jsonData = await productData.json();
            return jsonData;
        } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
        }
    };

    const updateWishlist = async (data) => {
        try {
            const response = await fetch('https://maison-territo-backend.vercel.app/api/update-customer-wishlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(data)
            })
            if (!response.ok) throw new Error('Failed to update wishlist');
            return response.json();
        } catch (error) {
            console.error('Error updating wishlist:', error);
        }
    }

    const removeWishlist = async (data) => {

        try {
            const response = await fetch('https://maison-territo-backend.vercel.app/api/delete-from-wishlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
            if (!response.ok) throw new Error('Failed to remove from wishlist');
            return response.json();
        } catch (error) {
            console.error('Error removing from wishlist:', error);
        }
    }


    /* Adds event listeners for wishlist actions. */
    const addSwymEventListener = (swat) => {
        //code changes made by Swym for removed from Wishlist event begin
        swat.evtLayer.addEventListener(
            swat.JSEvents.removedFromWishlist,
            async (event) => {
                try {
                    const pdp = event.detail.d.du;
                    console.log("Product page URL:", pdp);
                    const match = pdp.match(/\/products\/([^/?]+)/);             // Extract product handle
                    if (!match) throw new Error("Invalid product handle.");
                    const productHandle = match[1];
                    console.log("Extracted Product Handle:", productHandle);
                    const locale = window.Shopify?.locale || ""; // Determine locale and construct request URL
                    let reqURL = locale ? `/${locale}/products/${productHandle}.js` : `/products/${productHandle}.js`;
                    console.log("Fetching product data from:", reqURL);
                    let response = await fetch(reqURL); // Fetch product data
                    if (!response.ok) {
                        console.warn("First request failed, retrying without locale...");
                        reqURL = `/products/${productHandle}.js`;
                        response = await fetch(reqURL);
                    }
                    const jsonData = await response.json();
                    console.log("Product JSON Data:", jsonData);
                    if (!jsonData?.variants?.length) throw new Error("Invalid product data.");

                    // Extract image and title
                    const image = jsonData.variants[0]?.featured_image?.src
                        || (jsonData.images?.length ? `https:${jsonData.images[0]}` : "");
                    console.log("Product Image:", image || "No valid image found");

                    // Display notification
                    showCustomNotification(swat, image, jsonData.title || "Unknown Product", "remove", 1);

                    // Refresh wishlist
                    refreshList(swat);

                    const data = {
                        "customerId": `${window.customer.id}`,
                        "customerFirstName": `${window.customer.firstName}`,
                        "customerLastName": `${window.customer.lastName}`,
                        "customerEmail": `${window.customer.email}`,
                        "wishlistItem":
                        {
                            "productId": `${jsonData?.id}`,
                            "name": `${jsonData?.title}`,
                            "creation_date": new Date().toLocaleDateString('fr-FR')
                        }
                    }
                    const removeResponse = await removeWishlist(data);
                    console.log(removeResponse, 'RESPONSE')
                    if (window.customer && window.customer.isLoggedIn) {
                    }

                } catch (error) {
                    console.error("Error fetching or processing product data:", error);
                }
            }
        );
        // code changes end

        swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, async (event) => {
            let image = event.detail.d.iu;
            let title = event.detail.d.dt;

            const pdp = event.detail.d.du;

            const match = pdp.match(/\/products\/([^/?]+)/);             // Extract product handle

            if (!match) throw new Error("Invalid product handle.");

            const productHandle = match[1];

            console.log("Extracted Product Handle:", productHandle);

            const locale = window.Shopify?.locale || ""; // Determine locale and construct request URL

            let reqURL = locale ? `/${locale}/products/${productHandle}.js` : `/products/${productHandle}.js`;

            console.log(reqURL)

            let response = await fetch(reqURL); // Fetch product data

            if (!response.ok) {
                console.warn("First request failed, retrying without locale...");
                reqURL = `/products/${productHandle}.js`;
                response = await fetch(reqURL);
            }
            const jsonData = await response.json();
            if (!jsonData?.variants?.length) throw new Error("Invalid product data.");


            showCustomNotification(swat, image, title, 'add', 1);
            refreshList(swat);

            const data = {
                "customerId": `${window.customer.id}`,
                "customerFirstName": `${window.customer.firstName}`,
                "customerLastName": `${window.customer.lastName}`,
                "customerEmail": `${window.customer.email}`,
                "wishlistItem":
                {
                    "productId": `${jsonData?.id}`,
                    "name": `${jsonData?.title}`,
                    "creation_date": new Date().toLocaleDateString('fr-FR')
                }
            }


            const updateResponse = await updateWishlist(data);
            console.log(updateResponse, 'UPDATE RESPONSE')
            if (window.customer && window.customer.isLoggedIn) {
            }
        });

        swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
            const currentVariant = data.detail.d.variant.id;
            const currentProductId = data.detail.d.product.id;
            const swymCustomWishlistButton = document.querySelector(`.swymcs-wishlist-button-${currentProductId}`);
            if (swymCustomWishlistButton) {
                swymCustomWishlistButton.setAttribute('data-epi', currentVariant);
            }
            setTimeout(updateButtonState, 200);
        });
    };

    const showCustomNotification = (swat, image, title, action, listCount) => {
        let successMessage = `
      <style>
          .swym-notification-success-inner .swym-image{ display: none !important }
          #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
          #swym-custom-notification-content #swym-custom-image-container { min-height: 50px; min-width: 50px; max-height: 50px; max-width: 50px }
          #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; border-radius: 50% }
          #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
      </style>
      <div id="swym-custom-notification-content" onclick="_swat.ui.open()">
          <div id="swym-custom-image-container">
              <img id="swym-custom-image" src="${image}" alt="wishlisted product image"/>
          </div>
          <div id="swym-custom-title-conatainer"><strong>${title}</strong> ${window.cartStrings.hasBeen} ${action == 'remove' ? `${window.cartStrings.removedFrom}` : `${window.cartStrings.addedTo}`} <strong> ${listCount == 1 ? `${window.cartStrings.list}!` : `${window.cartStrings.lists}`}</strong></div>
      </div>
    `;
        swat.ui.showSuccessNotification({ message: successMessage });
    }

    /* Creating a global object to assign functions */
    const swymcsWishlistFunctions = {
        init,
        fetchList,
        createList,
        refreshList,
        updateButtonState,
        updateButtonWishlistState,
        addToWishlist,
        removeFromWishlist,
        addSwymEventListener,
        fetchProductsData,
        renderPopup,
        showCustomNotification
    };

    /* Expose swymcsWishlistFunctions to the global scope */
    window.swymcsWishlistFunctions = swymcsWishlistFunctions;

    /* Push the init functions into SwymCallbacks */
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymcsWishlistFunctions.init);

    console.log(window.SwymCallbacks);

    /* Initialize when document is ready if Swym is already loaded */
    document.addEventListener('DOMContentLoaded', function () {
        if (window._swat) {
            swymcsWishlistFunctions.init(window._swat);
        }
    });
})();

if (!customElements.get('swymcs-wishlist-button')) {
    class SwymWishlistButton extends HTMLElement {
        constructor() {
            super();
            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(this.initializeSwymButton.bind(this));
        }

        async initializeSwymButton(swat) {
            var swymWishlistButtonElement = this;
            this.elements = {
                wishlistButton: swymWishlistButtonElement.querySelector('button'),
                unfilledState: swymWishlistButtonElement.querySelector('#swymUnfilled'),
                filledState: swymWishlistButtonElement.querySelector('#swymFilled'),
            };

            console.log(this.elements);

            this.elements.wishlistButton.addEventListener('click', () => {
                console.log('clicked')
                let { epi, empi, du } = this.elements.wishlistButton.dataset;
                let product = { epi, empi, du };
                if (swat.isCollectionsEnabled()) {
                    swymcsWishlistFunctions.renderPopup(product);
                } else {
                    if (this.elements.wishlistButton.classList.contains('swym-added-custom')) {
                        swymcsWishlistFunctions.removeFromWishlist(swat, product);
                    } else {
                        swymcsWishlistFunctions.addToWishlist(swat, product);
                    }
                }
            });
        }
    }
    customElements.define('swymcs-wishlist-button', SwymWishlistButton);
}